var _mask, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3100_142230",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75H20.25V3.75H8.25V8.25"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.75C15.1977 14.75 14.75 15.1977 14.75 15.75C14.75 16.3023 15.1977 16.75 15.75 16.75V14.75ZM20.25 15.75V16.75C20.8023 16.75 21.25 16.3023 21.25 15.75H20.25ZM20.25 3.75H21.25C21.25 3.19772 20.8023 2.75 20.25 2.75V3.75ZM8.25 3.75V2.75C7.69772 2.75 7.25 3.19772 7.25 3.75H8.25ZM7.25 8.25C7.25 8.80228 7.69772 9.25 8.25 9.25C8.80228 9.25 9.25 8.80228 9.25 8.25H7.25ZM15.75 16.75H20.25V14.75H15.75V16.75ZM21.25 15.75V3.75H19.25V15.75H21.25ZM20.25 2.75H8.25V4.75H20.25V2.75ZM7.25 3.75V8.25H9.25V3.75H7.25Z",
    fill: "#212529",
    mask: "url(#path-1-inside-1_3100_142230)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 19.75V8.75H15.25V19.75H4.25Z",
    stroke: "#212529",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.38b0448378b169b7a75f891e8421b152.svg";
export { ForwardRef as ReactComponent };